import { Navigate, Route, Routes } from "react-router";

import AuthorizedRoute from "../components/Routes/AuthorizedRoutes";

import IleggelseOrginalbilde from "../components/Common/Ileggelser/Detalj/IleggelseOrginalbilde";
import IleggelseImageEditorPageContainer from "../components/Common/Ileggelser/Detalj/ImageEditorPageContainer";
import MiljogebyrImageEditorPageContainer from "../components/Common/Miljogebyr/Detalj/ImageEditorPageContainer";
import MiljogebyrOrginalbilde from "../components/Common/Miljogebyr/Detalj/MiljogebyrOrginalbilde";
import TidskontrollOrginalbilde from "../components/Common/Miljogebyr/Detalj/TidskontrollOrginalbilde";
import InnsynIleggelseDetaljPage from "../components/Innsyn/InnsynIleggelseDetaljPage";
import InnsynIleggelsePage from "../components/Innsyn/InnsynIleggelsePage";
import InnsynMiljogebyrDetaljPage from "../components/Innsyn/InnsynMiljogebyrDetaljPage";
import InnsynMiljogebyrPage from "../components/Innsyn/InnsynMiljogebyrPage";
import InnsynMotorvognPage from "../components/Innsyn/InnsynMotorvognPage";
import InnsynMotorvognUtskriftPage from "../components/Innsyn/InnsynMotorvognUtskriftPage";
import InnsynPersonopplysningerPage from "../components/Innsyn/InnsynPersonopplysningerPage";

import {
    bypatruljen,
    ileggelseadmin,
    innsyn,
    juridisk,
} from "../constants/roles";
import sitePath from "../constants/sitePaths";
import { getRedirectPath } from "../utils/pathnameUtils";

const INNSYN_ROLES = [
  innsyn.vaktsentralen,
  innsyn.serviceavdeling,
  innsyn.kemnerkontoret,
  innsyn.seksjonssjefVaktsentralen,
];
const MOTORVOGN_ROLES = [
  ...Object.values(bypatruljen),
  ...Object.values(juridisk),
  ...INNSYN_ROLES,
];

const Innsyn = () => {
  return (
    <Routes>
      {/* ileggelser */}
      <Route path="ileggelser">
        <Route index element={<Navigate to={sitePath.innsyn.ileggelser.oversikt} replace />} />
        <Route path="oversikt" element={<AuthorizedRoute roles={INNSYN_ROLES}><InnsynIleggelsePage /></AuthorizedRoute>} />
        <Route path=":id">
          <Route index element={<AuthorizedRoute roles={INNSYN_ROLES}><InnsynIleggelseDetaljPage /></AuthorizedRoute>} />
          <Route path="bilder/:bildeId">
            <Route index element={<AuthorizedRoute roles={INNSYN_ROLES}><IleggelseOrginalbilde /></AuthorizedRoute>} />
            <Route path="rediger" element={<AuthorizedRoute roles={INNSYN_ROLES}><IleggelseImageEditorPageContainer /></AuthorizedRoute>} />
          </Route>
        </Route>
      </Route>

      {/* miljogebyrer */}
      <Route path="miljogebyrer">
        <Route index element={<Navigate to={sitePath.innsyn.miljogebyrer.oversikt} replace />} />
        <Route path="oversikt" element={<AuthorizedRoute roles={INNSYN_ROLES}><InnsynMiljogebyrPage /></AuthorizedRoute>} />
        <Route path=":id">
          <Route index element={<AuthorizedRoute roles={INNSYN_ROLES}><InnsynMiljogebyrDetaljPage /></AuthorizedRoute>} />
          <Route path="bilder/:bildeId">
            <Route index element={<AuthorizedRoute roles={INNSYN_ROLES}><MiljogebyrOrginalbilde /></AuthorizedRoute>} />
            <Route path="rediger" element={<AuthorizedRoute roles={INNSYN_ROLES}><MiljogebyrImageEditorPageContainer /></AuthorizedRoute>} />
          </Route>
        </Route>
        <Route path=":miljogebyrId/tidskontroller/:miljokontrollId/observasjoner/:observasjonId/bilder/:bildeId">
          <Route index element={<AuthorizedRoute roles={INNSYN_ROLES}><TidskontrollOrginalbilde /></AuthorizedRoute>} />
          <Route path="rediger" element={<AuthorizedRoute roles={INNSYN_ROLES}><MiljogebyrImageEditorPageContainer /></AuthorizedRoute>} />
        </Route>
      </Route>

      {/* motorvogn */}
      <Route path="motorvogn">
        <Route index element={<AuthorizedRoute roles={MOTORVOGN_ROLES}><InnsynMotorvognPage /></AuthorizedRoute>} />
        <Route path="utskrift" element={<AuthorizedRoute roles={MOTORVOGN_ROLES}><InnsynMotorvognUtskriftPage /></AuthorizedRoute>} />
      </Route>

      {/* personopplysninger */}
      <Route path="personopplysninger" element={<AuthorizedRoute roles={[ileggelseadmin]}><InnsynPersonopplysningerPage /></AuthorizedRoute>} />

      <Route index element={<Navigate to={getRedirectPath(sitePath.innsyn.shortUrl)} replace />} />
    </Routes>
  );
};

export default Innsyn;
